import React from 'react';

export default () => (
    <div className={'container'}><h2>Ovalview </h2>
        <p>Version {process.env.REACT_APP_VERSION}</p>
    </div>
);
